/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingtoolsdescription2Inputs */

const en_crosspostingtoolsdescription2 = /** @type {(inputs: Crosspostingtoolsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect this place's social accounts and choose what to post.`)
};

const de_crosspostingtoolsdescription2 = /** @type {(inputs: Crosspostingtoolsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde die Social-Media-Konten dieses Ortes und wähle, was du posten möchtest.`)
};

/**
* | output |
* | --- |
* | "Connect this place's social accounts and choose what to post." |
*
* @param {Crosspostingtoolsdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingtoolsdescription2 = /** @type {((inputs?: Crosspostingtoolsdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingtoolsdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingtoolsdescription2(inputs)
	return de_crosspostingtoolsdescription2(inputs)
});
export { crosspostingtoolsdescription2 as "crosspostingToolsDescription" }